export default __webpack_public_path__ + "static/media/omni-m.3ec5a4c4.jpeg";